import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';

import { staticURL } from 'core/url';
import { ComponentRegistry } from 'core/registry';
import { ModalTitle, Divider } from 'legacyComponents/styled/lib';
import { Button, Paragraph } from 'components';
import { Modal } from 'apps/modals/views/modal';

@withNamespaces()
@inject('clientStore')
@observer
export class NoRobotsModal extends Modal {
  render() {
    // TODO
    // potentially swap out signedInProfile for param from error handler.
    const authenticated = this.props.clientStore.signedInProfile;
    return (
      <>
        <ModalTitle>
          <Trans>Action failed.</Trans>
        </ModalTitle>
        <Divider />
        <ModalContent>
          <Image src={staticURL('/assets/pictograms/robot.svg')} />
          <Paragraph variant='primary'>
            <strong>
              <Trans>Hmm... our system seems to think you are a robot.</Trans>
            </strong>
          </Paragraph>
          {authenticated ? (
            <Paragraph variant='primary'>
              <Trans>
                Please contact support so we can re-enable these kinds of
                actions for you. Thanks!
              </Trans>
            </Paragraph>
          ) : (
            <Paragraph variant='primary'>
              <Trans>
                Please send us an email (support@wikifactory.com) from your
                preferred email address, and we&apos;ll send you an invite.
                Thanks!
              </Trans>
            </Paragraph>
          )}
          <nav>
            <a href='mailto:support@wikifactory.com?subject=I am not robot, promise!'>
              <ButtonStyled text={<Trans>Email Support</Trans>} outline />
            </a>
          </nav>
        </ModalContent>
      </>
    );
  }
}

const Image = styled.img`
  width: 25%;
  height: auto;
  margin-bottom: ${props => props.theme.spacing.medium};
`;

const ButtonStyled = styled(Button)`
  margin: ${props =>
    `${props.theme.spacing.large} ${props.theme.spacing.small} 0`};
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.medium};
  text-align: center;
`;

ComponentRegistry.add('modals.NoRobotsModal', NoRobotsModal);
